<template>
  <div>
    <v-row>
      <v-col class="d-flex" cols="6">
        <app-text-field
          label="Data"
          solo
          flat
          background-color="grey lighten-4"
          v-model="params.date_start"
          type="date"
        />

        <app-text-field
          class="mx-5"
          label="Data"
          solo
          flat
          background-color="grey lighten-4"
          v-model="params.date_end"
          type="date"
        />

        <v-select
          label="Agrupar por"
          solo
          flat
          dense
          background-color="grey lighten-4"
          v-model="will_group_by"
          :items="groupByOptions"
        />

        <v-btn class="mx-5" color="primary" elevation="0" @click="select()">
          Pesquisar
        </v-btn>
      </v-col>
      <v-col></v-col>
      <v-col></v-col>
      <v-col></v-col>
      <v-col>
        <v-btn
          class="ml-5"
          color="success"
          @click="copyTableToClipboard('all-tables')"
        >
          <v-icon left>mdi-file-export</v-icon>
          Copiar pra Excel
        </v-btn>
      </v-col>
    </v-row>

    <v-divider class="my-8" />

    <div class="scroll-x-wrapper">
      <div id="all-tables">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <!-- ################################ Seção 1.1 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("1.1").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>
                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('1.1')
                  .account_plans"
              >
                <tr :key="'1.1-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>

                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      width="10%"
                      class="text-right text-no-wrap clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>

              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">{{
                    $format.decimal(getAccountPlanGroupTotalSum("1.1"))
                  }}</b>
                </td>

                <template v-for="(date, index) of getDate()">
                  <td width="10%" class="text-right text-no-wrap" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("1.1", date)) }}
                    </b>
                  </td>
                </template>
              </tr>

              <!-- ################################ Seção 2.1 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("2.1").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>
                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('2.1')
                  .account_plans"
              >
                <tr :key="'2.1-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>
                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      class="text-right text-no-wrap clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>

              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">
                    {{ $format.decimal(getAccountPlanGroupTotalSum("2.1")) }}
                  </b>
                </td>

                <template v-for="(date, index) of getDate()">
                  <td class="text-right text-no-wrap" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("2.1", date)) }}
                    </b>
                  </td>
                </template>
              </tr>

              <!-- ################################ Seção 2.2 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("2.2").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>

                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('2.2')
                  .account_plans"
              >
                <tr :key="'2.2-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>
                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      class="text-right text-no-wrap clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>
              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">
                    {{ $format.decimal(getAccountPlanGroupTotalSum("2.2")) }}
                  </b>
                </td>

                <template v-for="(date, index) of getDate()">
                  <td class="text-right text-no-wrap" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("2.2", date)) }}
                    </b>
                  </td>
                </template>
              </tr>

              <!-- ################################ Seção 2.3 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("2.3").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>
                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('2.3')
                  .account_plans"
              >
                <tr :key="'2.3-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>

                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      class="text-right text-no-wrap clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>

              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">
                    {{ $format.decimal(getAccountPlanGroupTotalSum("2.3")) }}
                  </b>
                </td>

                <template v-for="(date, index) of getDate()">
                  <td class="text-right text-no-wrap" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("2.3", date)) }}
                    </b>
                  </td>
                </template>
              </tr>

              <!-- ################################ Seção 2.4 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("2.4").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>
                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('2.4')
                  .account_plans"
              >
                <tr :key="'2.4-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>

                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      class="text-right clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>

              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">
                    {{ $format.decimal(getAccountPlanGroupTotalSum("2.4")) }}
                  </b>
                </td>

                <template v-for="(date, index) of getDate()">
                  <td class="text-right" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("2.4", date)) }}
                    </b>
                  </td>
                </template>
              </tr>

              <!-- ################################ Seção 1.2 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("1.2").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>
                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('1.2')
                  .account_plans"
              >
                <tr :key="'1.2-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>

                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      class="text-right text-no-wrap clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>

              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">
                    {{ $format.decimal(getAccountPlanGroupTotalSum("1.2")) }}
                  </b>
                </td>
                <template v-for="(date, index) of getDate()">
                  <td class="text-right text-no-wrap" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("1.2", date)) }}
                    </b>
                  </td>
                </template>
              </tr>

              <!-- ################################ Seção 2.5 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("2.5").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>
                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('2.5')
                  .account_plans"
              >
                <tr :key="'2.5-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>

                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      class="text-right text-no-wrap clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>

              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">
                    {{ $format.decimal(getAccountPlanGroupTotalSum("2.5")) }}
                  </b>
                </td>
                <template v-for="(date, index) of getDate()">
                  <td class="text-right text-no-wrap" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("2.5", date)) }}
                    </b>
                  </td>
                </template>
              </tr>

              <!-- ################################ Seção 1.3 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("1.3").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>
                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('1.3')
                  .account_plans"
              >
                <tr :key="'1.3-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>

                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      class="text-right text-no-wrap clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>

              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">
                    {{ $format.decimal(getAccountPlanGroupTotalSum("1.3")) }}
                  </b>
                </td>

                <template v-for="(date, index) of getDate()">
                  <td class="text-right text-no-wrap" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("1.3", date)) }}
                    </b>
                  </td>
                </template>
              </tr>

              <!-- ################################ Seção 2.6 ######################### -->
              <tr class="section-header">
                <td class="sticky-col">
                  <h4 class="account-plan-group">
                    {{ getAccountPlanGroup("2.6").name }}
                  </h4>
                </td>
                <td colspan="100%"></td>
              </tr>

              <tr class="dates-header">
                <th class="sticky-col">Conta</th>

                <template v-for="(date, index) of getDate()">
                  <th
                    width="10%"
                    class="text-right text-no-wrap min-w-ceil"
                    :key="index"
                  >
                    {{ formatDate(date) }}
                  </th>
                </template>
              </tr>

              <template
                v-for="(account_plan, index) of getAccountPlanGroup('2.6')
                  .account_plans"
              >
                <tr :key="'2.6-' + index">
                  <td
                    class="text-no-wrap min-w-400 sticky-col d-flex  justify-space-between gap"
                  >
                    <span>{{ account_plan.name }} </span>
                    <span class="pt-1">
                      {{
                        $format.decimal(getAccountPlanTotal(account_plan.id))
                      }}
                    </span>
                  </td>

                  <template v-for="(date, idx) of getDate()">
                    <td
                      @click="handleAccountPlanClick(account_plan.id, date)"
                      class="text-right text-no-wrap clickable"
                      :key="idx"
                    >
                      {{
                        $format.decimal(
                          getAccountPlanValue(account_plan.id, date)
                        )
                      }}
                    </td>
                  </template>
                </tr>
              </template>

              <tr class="total-row">
                <td class="sticky-col d-flex justify-space-between gap">
                  <b>Total</b>
                  <b class="pt-1">
                    {{ $format.decimal(getAccountPlanGroupTotalSum("2.6")) }}
                  </b>
                </td>

                <template v-for="(date, index) of getDate()">
                  <td class="text-right text-no-wrap" :key="index">
                    <b class="total">
                      {{ $format.decimal(getAccountPlanGroupSum("2.6", date)) }}
                    </b>
                  </td>
                </template>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  format,
  startOfMonth,
  endOfMonth,
  lastDayOfMonth,
  parseISO,
  eachMonthOfInterval,
  subMonths,
  differenceInDays,
} from "date-fns";

import AppDatePicker from "@/components/app/ui/AppDatePicker";
import AccountTransactionLabel from "@/components/account/sections/AccountTransactionLabel.vue";
import AccountTransactionDialog from "@/components/account/sections/AccountTransactionDialog";
import AccountSelect from "@/components/account/ui/AccountSelect.vue";

export default {
  components: {
    AppDatePicker,
    AccountTransactionLabel,
    AccountTransactionDialog,
    AccountSelect,
  },

  data() {
    return {
      accountPlanGroups: [],
      accountTransactions: [],
      dates: [],
      data: [],
      months: [],
      days: [],
      date: format(new Date(), "yyyy-MM"),
      params: {
        account_plan_id_diferent: null,
        date_start: null,
        date_end: null,
        status: ["paid"],
        group_by: "month",
      },

      will_group_by: "month",

      groupByOptions: [
        { text: "Mês", value: "month" },
        { text: "Dia", value: "day" },
      ],
    };
  },

  async mounted() {
    await this.setDateParams();

    this.setMonths();

    await this.selectAccountPlans();

    await this.select();
  },

  methods: {
    setDateParams() {
      this.params.date_start = format(
        startOfMonth(subMonths(new Date(), 6)),
        "yyyy-MM-dd"
      );

      this.params.date_end = format(lastDayOfMonth(new Date()), "yyyy-MM-dd");
    },

    setMonths() {
      let months = eachMonthOfInterval({
        start: parseISO(this.params.date_start),
        end: parseISO(this.params.date_end),
      });

      this.months = months.map((month) => format(month, "yyyy-MM"));
    },

    setDays() {
      let days = this.accountTransactions.map(
        (transaction) => transaction.date_day
      );

      this.days = [...new Set(days)];
    },

    async selectAccountPlans() {
      await this.$http.index("account/account-plan-group").then((response) => {
        this.accountPlanGroups = response.accountPlanGroups;
      });
    },

    async select() {
      this.setGroupBy();

      await this.$http
        .index("bi/account-transaction", this.params)
        .then((response) => {
          this.accountTransactions = response.accountTransactions;
        });

      if (this.params.group_by == "day") {
        this.setDays();
      } else {
        this.setMonths();
      }
    },

    getAccountPlanGroup(groupCode) {
      let accountPlanGroup = this.accountPlanGroups.filter(
        (value) => value.code == groupCode
      );
      if (accountPlanGroup[0]) {
        return accountPlanGroup[0];
      }

      return {};
    },

    getDate() {
      const arr = this.params.group_by == "day" ? this.days : this.months;
      return [...arr].sort();
    },

    formatDate(date) {
      return this.params.group_by == "day"
        ? this.$format.dateBr(date)
        : this.$format.monthYearBr(date);
    },

    setGroupBy() {
      const start = parseISO(this.params.date_start);
      const end = parseISO(this.params.date_end);

      const daysDiff = differenceInDays(end, start);

      this.params.group_by = daysDiff > 32 ? "month" : this.will_group_by;

      this.will_group_by = this.params.group_by;
    },

    getAccountPlanValue(accountPlanId, date) {
      let row = this.accountTransactions.filter(
        (value) =>
          value.account_plan_id == accountPlanId &&
          (this.params.group_by == "day"
            ? value.date_day == date
            : value.date_month == date)
      );

      if (row.length > 0) {
        return row[0].value_sum;
      }

      return 0;
    },

    getAccountPlanTotal(accountPlanId) {
      let total = 0;

      for (let date of this.getDate()) {
        total += Number(this.getAccountPlanValue(accountPlanId, date));
      }

      return total;
    },

    getAccountPlanGroupTotalSum(code) {
      let accountPlans = this.getAccountPlanGroup(code).account_plans;

      if (typeof accountPlans == "undefined") {
        return 0;
      }

      var sum = 0;

      for (let accountPlan of accountPlans) {
        if (accountPlan) {
          sum += Number(this.getAccountPlanTotal(accountPlan.id));
        }
      }

      return sum;
    },

    getAccountPlanGroupSum(code, month) {
      let accountPlans = this.getAccountPlanGroup(code).account_plans;

      if (typeof accountPlans == "undefined") {
        return 0;
      }

      var sum = 0;

      for (let accountPlan of accountPlans) {
        if (accountPlan) {
          sum += Number(this.getAccountPlanValue(accountPlan.id, month));
        }
      }

      return sum;
    },

    getVariableCostsSum() {
      return (
        this.getAccountPlanGroupSum("2.1") + this.getAccountPlanGroupSum("2.2")
      );
    },

    getGrossProfit() {
      return this.getAccountPlanGroupSum("1.1") + this.getVariableCostsSum();
    },

    getGrossProfitPercent() {
      return (this.getGrossProfit() * 100) / this.getAccountPlanGroupSum("1.1");
    },

    getOperationalProfit() {
      return (
        this.getGrossProfit() +
        this.getAccountPlanGroupSum("2.3") +
        this.getAccountPlanGroupSum("2.4")
      );
    },

    getNetProfit() {
      return (
        this.getOperationalProfit() +
        this.getAccountPlanGroupSum("1.2") +
        this.getAccountPlanGroupSum("2.5")
      );
    },

    getResult() {
      return this.$calc.sum(this.accountTransactions, "value_sum");
    },

    handleAccountPlanClick(accountPlanId, date_month) {
      const date = parseISO(date_month, "yyyy-MM-dd", new Date());

      const start_at = startOfMonth(date);
      const end_at = endOfMonth(date);

      window.open(
        this.$router.resolve({
          name: "cashFlowIndex",
          query: {
            accountPlanId: accountPlanId,
            start_date: format(start_at, "yyyy-MM-dd"),
            end_date: format(end_at, "yyyy-MM-dd"),
          },
        }).href,
        "_blank"
      );
    },

    copyTableToClipboard(containerId) {
      const containers = document.querySelectorAll(`#${containerId}`);

      const allLines = [];

      let isFirstTitle = true;

      containers.forEach((container, containerIndex) => {
        const table = container.querySelector("table");

        if (table) {
          for (const row of table.rows) {
            const cells = Array.from(row.cells).map((cell) => {
              return cell.innerText
                .replace(/\t/g, " ")
                .replace(/\r?\n/g, " ")
                .trim();
            });

            const hasTitle = row.querySelector(".account-plan-group");

            if (hasTitle && !isFirstTitle) {
              allLines.push("");
              allLines.push("");
              allLines.push("");
              allLines.push("");
            }

            if (hasTitle) {
              isFirstTitle = false;
            }

            allLines.push(cells.join("\t"));
          }
        }
      });

      const tsv = allLines.join("\n");

      navigator.clipboard
        .writeText(tsv)
        .then(() => {
          this.$snackbar({
            message: `tabelas copiadas para o clipboard`,
            props: {
              color: "success",
              timeout: 3000,
            },
          });
        })
        .catch(() => {
          this.$snackbar({
            message: "Erro ao copiar para o clipboard",
            props: {
              color: "error",
              timeout: 3000,
            },
          });
        });
    },
  },
};
</script>

<style scoped>
#all-tables {
  min-width: 100%;
}

.section-header h4 {
  margin: 0;
  font-size: 14px;
  padding: 12px 0;
  text-align: center;
}

.dates-header th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #1e1e1e;
}

.min-w-400 {
  min-width: 400px !important;
}

.min-w-ceil {
  min-width: 130px !important;
}

.clickable {
  cursor: pointer;
}

.total {
  color: #111111;
}

.gap {
  gap: 1rem;
}

.sticky-col {
  position: sticky !important;
  left: 0;
  z-index: 3;
  background: white;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}
</style>
